module.exports = __webpack_public_path__ + "img/Banner3.1ff4a092.png";